// One rule for how a takeoff quantity is rounded and shown (owner decision 2026-10-19):
//   * LF and SF read as WHOLE numbers everywhere — canvas labels, Conditions dock, legend, Σ Totals, report, CSV, Estimate.
//   * The Estimate multiplies the quantity it SHOWS: a takeoff line's LF / SF is rounded to a whole number BEFORE it is
//     priced, so Qty × Unit price = the line total, always. (A quantity the estimator typed is used exactly as typed.)
//   * Rounding of each drawn shape per the condition's own setup (Round length to / Round area to, Setup ▸ Estimate Engine ▸
//     Items) happens first, per shape, in the takeoff — this is the final step on top of that sum.
// Other units (EA, tile counts, CF…) are never rounded here.
const WHOLE_UNITS = new Set(["lf", "sf"]);

export const isWholeUnit = (uom) => WHOLE_UNITS.has(String(uom ?? "").trim().toLowerCase());

/** The quantity a takeoff line prices at: whole for LF / SF, unchanged for anything else (and for non-numbers). */
export function roundForPricing(q, uom) {
  const n = Number(q);
  if (!Number.isFinite(n) || !isWholeUnit(uom)) return q;
  return Math.round(n) + 0; // never -0
}
